
































import {
  defineComponent,
  PropType,
  toRefs,
  ref,
  computed
} from '~/utils/nuxt3-migration'
import { SmartClassified } from '~/models/search-bar'
import CClassifiedThumbnail from '~/components/shared/configurable/classified/image/CClassifiedThumbnail.vue'
import { useRouter } from '@nuxtjs/composition-api'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_SEARCH_NS,
  SearchState
} from '~/store/modules/shared/classifieds/search/state'
import { SET_REFS } from '~/store/modules/shared/classifieds/view/mutation-types'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
export default defineComponent({
  components: { CClassifiedThumbnail },
  props: {
    classified: {
      type: Object as PropType<SmartClassified>,
      required: true
    }
  },
  setup(props, { emit }) {
    const { classified } = toRefs(props)
    const router = useRouter()

    const { commit } = useNamespacedStore<SearchState>(CLASSIFIED_VIEW_NS)
    const { state } = useNamespacedStore<SearchState>(CLASSIFIED_SEARCH_NS)
    const thumbRef = ref(null)

    const rowsExtraQueryParams = computed(() => {
      return state.config?.settings?.rowsExtraQueryParams
    })

    function triggerThumbClick(e) {
      thumbRef.value.imgClicked(e)
    }
    function classifiedClicked(evt, refData = {}) {
      if (evt) {
        evt.preventDefault()
        if (evt.ctrlKey) {
          window.open(classified.value.url)
          return
        }
      }

      const refs = {
        categoryIds: refData.categoryIds || classified.value.category_ids,
        id: refData.id || classified.value.id,
        isParked: refData.isParked || null,
        thumb: refData.thumb || classified.value.thumb,
        title: refData.title || classified.value.title,
        price: refData.price || classified.value.price,
        salary: refData.salary || classified.value.salary,
        payment: refData.payment || classified.value.payment,
        thumbIndex: refData.thumbIndex || 0,
        offertype: refData.offertype || classified.value.offertype,
        hasPhotos: refData.hasPhotos || classified.value.has_photos,
        thumbsLength:
          refData.thumbsLength || (classified.value.has_photos ? 1 : 0),
        externalLink:
          refData.externalLink || classified.value.external_link || null
      }

      commit(SET_REFS, refs)
      emit('close-suggestions')

      return router.push({
        path: classified.value.url,
        query: rowsExtraQueryParams.value
      })
    }

    function onClick(evt: Event) {
      evt.preventDefault()
      emit('clicked', evt)
    }

    return {
      classifiedClicked,
      thumbRef,
      triggerThumbClick,
      onClick
    }
  }
})
